const DOT_COLORS = ['#e83a3a', '#ff9a8b', '#f7c59f', '#a8d5a2', '#9ec5fb'];

function rand(min: number, max: number) {
  return Math.random() * (max - min) + min;
}

export function burstLikeConfetti(cx: number, cy: number) {
  for (let i = 0; i < 9; i++) {
    const dot = document.createElement('div');

    dot.className = 'like-confetti-dot';
    const angle = rand(0, Math.PI * 2);
    const dist = rand(16, 44);
    const size = rand(3, 6);

    dot.style.cssText = `left:${cx - size / 2}px;top:${cy - size / 2}px;width:${size}px;height:${size}px;background:${DOT_COLORS[Math.floor(Math.random() * DOT_COLORS.length)]};--tx:${Math.cos(angle) * dist}px;--ty:${Math.sin(angle) * dist - rand(4, 12)}px;--dur:${rand(0.35, 0.55)}s`;
    document.body.appendChild(dot);
    dot.addEventListener('animationend', () => dot.remove(), { once: true });
    setTimeout(() => dot.remove(), 700);
  }

  for (let i = 0; i < 4; i++) {
    const heart = document.createElement('div');

    heart.className = 'like-confetti-heart';
    heart.textContent = '♥';
    const angle = rand(-Math.PI * 0.85, -Math.PI * 0.15);
    const dist = rand(18, 46);

    heart.style.cssText = `left:${cx}px;top:${cy}px;--fs:${rand(7, 12)}px;--tx:${Math.cos(angle) * dist}px;--ty:${Math.sin(angle) * dist}px;--dur:${rand(0.38, 0.58)}s`;
    document.body.appendChild(heart);
    heart.addEventListener('animationend', () => heart.remove(), { once: true });
    setTimeout(() => heart.remove(), 700);
  }
}
